'use strict';

require('./contact-us-modal.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _contactUsSuccess = require('./contact-us-success');

var _contactUsSuccess2 = _interopRequireDefault(_contactUsSuccess);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a Contact Us modal used on the HelloSign web and API pricing pages.
 */
var ContactUsModal = _react2['default'].createClass({
    displayName: 'ContactUsModal',


    propTypes: {
        'timePeriod': _react2['default'].PropTypes.string, // FIXME: We aren't actually using this
        'pricingSource': _react2['default'].PropTypes.string,
        'headerText': _react2['default'].PropTypes.string,
        'onSuccess': _react2['default'].PropTypes.func
    },

    getInitialState: function getInitialState() {
        return {
            'timePeriod': 'Y'
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            'onSuccess': void 0,
            'headerText': 'Need to add more seats?'
        };
    },
    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },


    // Set up handler for when form is successfully submitted
    handleMarketoFormLoaded: function handleMarketoFormLoaded(form) {
        form.onSuccess(function () {
            // Show thank you message
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
            hellofaxJS.trackGoogleAnalyticsEvent('sales', 'contactus');
            if (this.props.onSuccess) {
                this.props.onSuccess();
            } else {
                var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal_success', 'medium');
                _reactDom2['default'].render(_react2['default'].createElement(_contactUsSuccess2['default'], null), attachPoint);
            }

            // Return false to prevent the submission handler from taking the lead to the follow up url
            return false;
        }.bind(this));
    },
    render: function render() {
        // Change some stuff based on the pricingSource (web or api)
        var modalHeader = this.props.headerText;
        var marketoFormId = 1116; // Non-API Pricing Page Form
        if (this.props.pricingSource == 'api') {
            modalHeader = 'Need more?';
            marketoFormId = 1115; // API Pricing Page Form
        } else if (this.props.pricingSource == 'eventbrite') {
            modalHeader = 'Need more?';
            marketoFormId = 1214; // Eventbrite Pricing Page Form
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-contact-us row text-center' },
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12' },
                _react2['default'].createElement(
                    'h3',
                    null,
                    modalHeader
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'row' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns small-10 small-offset-1 l-padding-t-10 l-padding-b-20' },
                    _react2['default'].createElement(
                        'p',
                        null,
                        'Please contact us below and we\'ll get back to you right away!'
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'columns small-12' },
                    _react2['default'].createElement(_marketoForm2['default'], { formId: marketoFormId, onLoad: this.handleMarketoFormLoaded, trackingId: 'contactus' })
                )
            )
        );
    }
});

module.exports = ContactUsModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/contact-us-modal.jsx
 ** module id = 1070
 ** module chunks = 0
 **/